import React, { FC } from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import ReactEchartsCore from 'echarts-for-react/lib/core';

export const FX: FC<{ data: any }> = ({ data, ...props }) => {

	const option = {
		grid: {
			left: 50,
			right: 20,
			top: 30,
		},
		// //图例
		// legend: {
		// 	type: "plain",
		// 	right: 0,

		// 	textStyle: {
		// 		color: "#fff"
		// 	},
		// 	data: [{
		// 		name: '过滤数量',
		// 		textStyle: {
		// 			color: '#fff'
		// 		},
		// 		icon: 'roundRect'
		// 	}, {
		// 		name: '识别数量',
		// 		textStyle: {
		// 			color: '#fff'
		// 		},
		// 		icon: 'roundRect'
		// 	}]
		// },
		//提示框
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'shadow'
			}
		},
		//直角坐标系 grid 中的 x 轴
		xAxis: {
			type: 'category',
			boundaryGap: false,
			axisTick: {
				show: false
			},
			axisLine: {
				lineStyle: {
					color: "#000000",
				}
			},
			// data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
			data: data.map((item: { shareDate: any; }) => item.shareDate)
		},
		//直角坐标系 grid 中的 y 轴
		yAxis: {
			type: 'value',
			axisLine: {
				lineStyle: {
					color: "#000000",
				}
			},
			//设置网格线颜色
			splitLine: {
				lineStyle: {
					color: ['#D9D9D9'],
				}
			},
		},

		dataZoom: [{
			type: 'inside',
			throttle: 50
		}],
		series: [
			{
				name: '分享数量',
				type: 'line',
				smooth: true,
				stack: 'a',
				itemStyle: {
					color: '#1890FF',
					borderWidth: 10,
				},
				areaStyle: {
					color: {
						type: 'linear',
						x: 1,
						y: 1,
						r: 1,
						colorStops: [{
							offset: 0, color: '#D6E3FD' // 0% 处的颜色
						}, {
							offset: 1, color: '#D6E3FD' // 100% 处的颜色
						}],
						globalCoord: false // 缺省为 false
					}
				},
				data: data.map((item: { shareNum: any; }) => item.shareNum)
			}
		]
	};

	return (
		<ReactEchartsCore
			className='wh100'
			echarts={echarts}
			theme="line"
			option={option as any}
		/>
	);
};

